/**
 * Obtiene o crea un UUID de usuario persistente
 * @returns {string} userUuid
 */
export const getOrCreateUserUuid = () => {
    let userUuid = localStorage.getItem('currentUserUuid');
    
    if (!userUuid) {
        userUuid = `user-${crypto.randomUUID()}`;
        localStorage.setItem('currentUserUuid', userUuid);
    }
    
    return userUuid;
};

/**
 * Obtiene o crea un email de usuario persistente
 * @returns {string} userEmail
 */
export const getOrCreateUserEmail = () => {
    let userEmail = localStorage.getItem('currentUserEmail');
    
    if (!userEmail) {
        userEmail = `anon-${crypto.randomUUID()}@propagile.com`;
        localStorage.setItem('currentUserEmail', userEmail);
    }
    
    return userEmail;
};

/**
 * Verifica si el usuario actual es anónimo
 * @returns {boolean}
 */
export const isAnonymousUser = () => {
    const userUuid = localStorage.getItem('currentUserUuid');
    
    // Es anónimo si:
    // 1. No hay userUuid
    // 2. El userUuid empieza con 'user-' (generado automáticamente)
    // 3. El userUuid empieza con 'anon-'
    if (!userUuid) return true;
    if (userUuid.startsWith('user-')) return true;
    if (userUuid.startsWith('anon-')) return true;
    
    // Si tiene formato UUID normal (sin prefijo), es usuario real
    return false;
};

/**
 * Limpia TODOS los datos de usuario anónimo
 * Se ejecuta en beforeunload para anónimos
 */
export const clearAnonymousUserData = () => {
    const userUuid = localStorage.getItem('currentUserUuid');
    
    if (userUuid && (userUuid.startsWith('user-') || userUuid.startsWith('anon-'))) {
        // Limpiar localStorage
        localStorage.removeItem('currentUserUuid');
        localStorage.removeItem('currentUserEmail');
        
        // Limpiar sessionStorage
        sessionStorage.clear();
        
        // Limpiar cookies anónimas
        document.cookie.split(";").forEach(cookie => {
            const name = cookie.split("=")[0].trim();
            if (name.includes('anon') || name.includes('session') || name.includes('temp')) {
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            }
        });
        
        return true;
    }
    
    return false;
};

/**
 * Obtiene información del usuario actual
 */
export const getCurrentUserInfo = () => {
    const userUuid = localStorage.getItem('currentUserUuid');
    const userEmail = localStorage.getItem('currentUserEmail');
    const isAnon = isAnonymousUser();
    
    return {
        userUuid,
        userEmail,
        isAnonymous: isAnon,
        type: isAnon ? 'anonymous' : 'authenticated'
    };
};